module.exports = __webpack_public_path__ + "static/media/blck13.f1cd7898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/black/blck13.jpg
// module id = 477
// module chunks = 0